export default __webpack_public_path__ + "static/media/Air Freight Services.d355da8b.jpg";